import { EntityNameType } from '@core/interfaces/entity-name-type';

export class LoadEntityNames {
  static readonly type = '[EntityNames] Load';

  constructor(public readonly entityType: EntityNameType) {}
}

export class AddEntityName {
  static readonly type = '[EntityNames] Add';

  constructor(public readonly entityType: EntityNameType, public readonly name: string) {}
}

export class UpdateEntityName {
  static readonly type = '[EntityNames] Update';

  constructor(
    public readonly entityType: EntityNameType,
    public readonly oldName: string,
    public readonly newName: string,
  ) {}
}

export class RemoveEntityName {
  static readonly type = '[EntityNames] Remove';

  constructor(public readonly entityType: EntityNameType, public readonly name: string) {}
}

